<template>
<p>
  <a :href='phoneLink' v-if='numberIsVisible' class='button-reset footer-cta t-label-regular bg-dark-blue c-white w-100 hover-bc-dark-blue'>
    <b v-text='phone'></b>
    <svg width="16" height="16">
      <use xlink:href='#phone'/>
    </svg>
  </a>
  <a :href='phoneLink' v-else class='button-reset footer-cta t-label-regular bg-dark-blue c-white mb-8 w-100 hover-bc-dark-blue' @click='numberIsVisible = true'>
    <slot></slot>
    <svg width="16" height="16">
      <use xlink:href='#phone'/>
    </svg>
  </a>
</p>
</template>

<script>
export default {
  name: 'ShowPhone',
  data() {
    return {
      numberIsVisible: false,
    }
  },
  props: {
    phone: {
      type: String,
      required: true,
    }
  },
  computed: {
    phoneLink() {
      return `tel:${this.phone.replace(/\s/g, '')}`
    }
  }
}
</script>
